import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

// Mixins / Modules
import { deparam, removeEmptyKeys } from '../../../../../modules/global';

// Modules
import { buildQueryString } from '@/modules/query_string';
import Persona from '../../../../../models/v2/persona';
import Profile from '../../../../../models/v2/profile';

// Related Components
import Departments from './roles/departments';
import EducationEntries from './roles/education_entries';
import ExperienceEntries from './roles/experience_entries';
import Industries from './roles/industries';
import Loading from './roles/loading';
import PlatformExpertise from './roles/platform_expertise';
import Role from './roles/role';
import Sidebar from './roles/sidebar';
import TechnicalExpertise from './roles/technical_expertise';

export default class Roles extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    const params = deparam(location.search.slice(1));
    this.state = {
      loading: true,
      currentPersonaId: parseInt(params.persona_id) || undefined,
      profile: {},
      personas: [],
    }
  }

  componentDidMount() {
    this.loadData();
  }

  get currentPersona() {
    const { personas, currentPersonaId } = this.state;
    return personas.find(({ id }) => id === currentPersonaId) || {};
  }

  loadData = () => {
    const { user } = this.props;
    Promise.all([
      Persona.where({ user_id_eq: user.id }).all(false),
      Profile.url(`/api/v2/users/${user.id}`).find('profile'),
    ])
      .then((values) => {
        this.setState({
          personas: values[0] || [],
          profile: values[1] || {},
          loading: false,
        })
      })
  }

  updateParams = ()  => {
    const { currentPersonaId } = this.state;
    const params = deparam(location.search.slice(1));
    const newParams = removeEmptyKeys(update(params, { $merge: { persona_id: currentPersonaId} }));
    const path = `${window.location.pathname}?${buildQueryString(newParams)}`;
    window.history.pushState({ url: path }, '', path);
  }

  handlePersonaChange = (currentPersonaId) => {
    this.setState({
      currentPersonaId
    }, () => this.updateParams());
  }

  render() {
    const { user } = this.props;
    const { loading, currentPersonaId, profile, personas } = this.state;

    if (loading) {
      return <Loading />
    }

    return (
      <div className='fixed-width-layout'>
        <div className='sidebar is-sticky'>
          <Sidebar {...{
            user,
            personas,
            currentPersonaId,
            onPersonaChange: this.handlePersonaChange,
          }} />
        </div>
        <div className='content'>
          <Role {...{
            user,
            persona: this.currentPersona,
          }} />
          <ExperienceEntries {...{
            key: `ee_${this.currentPersona.id}` || 'ee_all',
            user,
            profile,
            persona: this.currentPersona,
          }} />
          <PlatformExpertise {...{
            key: `pe_${this.currentPersona.id}` || 'pe_all',
            user,
            profile,
            persona: this.currentPersona,
          }} />
          <TechnicalExpertise {...{
            key: `te_${this.currentPersona.id}` || 'te_all',
            user,
            profile,
            persona: this.currentPersona,
          }} />
          <Departments {...{
            key: `d_${this.currentPersona.id}` || 'd_all',
            user,
            profile,
            persona: this.currentPersona,
          }} />
          <Industries {...{
            key: `i_${this.currentPersona.id}` || 'i_all',
            user,
            profile,
            persona: this.currentPersona,
          }} />
          <EducationEntries {...{
            key: `ede_${this.currentPersona.id}` || 'ede_all',
            user,
            profile,
            persona: this.currentPersona,
          }} />
        </div>
      </div>
    )
  }
}